const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3da6337199d2f57f1ce5b7d65d71e20bfd5e249f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["front@saweria"]={id:"3da6337199d2f57f1ce5b7d65d71e20bfd5e249f"};
      